<datex-grid #$gridComponent *ngIf="initialized " [selection]="true" (selectionChange)="$selectionChanged($event)" [headers]="headers" [rows]="rows" [(pageSize)]="pageSize" [(pageSkip)]="pageSkip" [totalCount]="totalCount" [loadingStatus]="loadingStatus" (pageChange)="$dataLoad()" [containerStyles]="containerStyles"
[canEdit]="canEdit"
[canAdd]="canAdd" [addNewRowFn]="addRow.bind(this)" [addLineModel]="bottomToolbar.addLine"

>
    <ng-container topToolbar>
      <app-toolbar [toolbar]="topToolbar">
          <ng-template 
            toolbarToolDef="delete_button" let-tool>
            <ng-container  *ngIf="tool.hasButtonsToShow">
            <button mat-button
                    data-cy="button"
                    class="datex-button"
                    [disabled]="tool.control.readOnly || tool.control.disabled"
                    [ngStyle]="tool.control.styles.style"
                    [ngClass]="tool.control.styles.classes"
                    [matTooltip]="tool.control.tooltip"
                    (click)="on_delete_clicked($event)"
                    >
              <div class="button-label">
                <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                  <div class="button-icon">
                    <i data-cy="button-icon" class="datex-default-spinner"></i>
                  </div>
                </ng-container>
                <ng-template #showIcon>
                  <div class="button-icon">
                    <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                  </div>
                </ng-template>
                <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
              </div>
            
            </button>
            </ng-container>
          </ng-template>
      </app-toolbar>
    <div class="query-filter">
      <input
        matInput
        [(ngModel)]="fullTextSearch" 
        (ngModelChange)="reload()" 
        [ngModelOptions]="{updateOn: 'blur'}"
        autocomplete="off"
        class="datex-textbox query-search"
        spellcheck="false"
        placeholder="Filter"
        [matTooltip]="fullTextSearch">
    </div>
  </ng-container>


  <ng-container gridColumnDef="warehouse">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.warehouse.displayControl.styles.style"
          [ngClass]="row.cells.warehouse.displayControl.styles.classes"
          [matTooltip]="row.cells.warehouse.displayControl.tooltip">{{row.cells.warehouse.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <ProgrammableLogicController-warehouses_dd_single 
        data-cy="selector"
        [type]="row.cells.warehouse.editControl.type"
        [formControl]="row.formGroup.controls['warehouse_edit']"
        (displayTextChange)="row.cells.warehouse.editControl.displayText=$event"
        [placeholder]="row.cells.warehouse.editControl.placeholder"
        [styles]="row.cells.warehouse.editControl.styles"
        [tooltip]="row.cells.warehouse.editControl.tooltip"
    >
    </ProgrammableLogicController-warehouses_dd_single>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="connector_name">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.connector_name.displayControl.styles.style"
          [ngClass]="row.cells.connector_name.displayControl.styles.classes"
          [matTooltip]="row.cells.connector_name.displayControl.tooltip">{{row.cells.connector_name.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <ProgrammableLogicController-connectors_dd_single 
        data-cy="selector"
        [type]="row.cells.connector_name.editControl.type"
        [formControl]="row.formGroup.controls['connector_name_edit']"
        (displayTextChange)="row.cells.connector_name.editControl.displayText=$event"
        [placeholder]="row.cells.connector_name.editControl.placeholder"
        [styles]="row.cells.connector_name.editControl.styles"
        [tooltip]="row.cells.connector_name.editControl.tooltip"
    >
    </ProgrammableLogicController-connectors_dd_single>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="connector_zone">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.connector_zone.displayControl.styles.style"
          [ngClass]="row.cells.connector_zone.displayControl.styles.classes"
          [matTooltip]="row.cells.connector_zone.displayControl.tooltip">{{row.cells.connector_zone.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <input data-cy="textBox" [formControl]="row.formGroup.controls['connector_zone_edit']"
            matInput
            autocomplete="off"
            spellcheck="false"
            class="datex-textbox {{ (row.cells.connector_zone.editControl.readOnly || row.cells.connector_zone.editControl.disabled) ? 'readonly ' : ''}}"
            placeholder="{{row.cells.connector_zone.editControl.placeholder}}"
            [ngStyle]="row.cells.connector_zone.editControl.styles.style"
            [ngClass]="row.cells.connector_zone.editControl.styles.classes"
            [matTooltip]="row.cells.connector_zone.editControl.tooltip"> 
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="footprint_zone">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.footprint_zone.displayControl.styles.style"
          [ngClass]="row.cells.footprint_zone.displayControl.styles.classes"
          [matTooltip]="row.cells.footprint_zone.displayControl.tooltip">{{row.cells.footprint_zone.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <ProgrammableLogicController-location_zone_dd_single 
        data-cy="selector"
        [type]="row.cells.footprint_zone.editControl.type"
        [formControl]="row.formGroup.controls['footprint_zone_edit']"
        (displayTextChange)="row.cells.footprint_zone.editControl.displayText=$event"
        [placeholder]="row.cells.footprint_zone.editControl.placeholder"
        [styles]="row.cells.footprint_zone.editControl.styles"
        [tooltip]="row.cells.footprint_zone.editControl.tooltip"
      [warehouseId]="row.$fields_footprint_zone_selector_inParams_warehouseId"
    >
    </ProgrammableLogicController-location_zone_dd_single>
    </ng-template>

  </ng-container>
  <ng-container gridColumnDef="connector_id">

    <ng-template gridCellDisplayControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.connector_id.displayControl.styles.style"
          [ngClass]="row.cells.connector_id.displayControl.styles.classes"
          [matTooltip]="row.cells.connector_id.displayControl.tooltip">{{row.cells.connector_id.displayControl.text }}</div>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <div data-cy="text" class="datex-text" 
          [ngStyle]="row.cells.connector_id.editControl.styles.style"
          [ngClass]="row.cells.connector_id.editControl.styles.classes"
          [matTooltip]="row.cells.connector_id.editControl.tooltip">{{row.cells.connector_id.editControl.text }}</div>
    </ng-template>

  </ng-container>

<ng-container bottomToolbar>
</ng-container>


</datex-grid>
